<template>
  <div class="button" @click="onclick">{{label}}</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Button',
  props: {
    label: String
  },
  methods: {
    onclick (e: Event) {
      // this.$emit('click', e)
    }
  }
})
</script>

<style lang="scss">
  .button {
    width: 240px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #626557;
    border-radius: 8px;
    color: white;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
</style>
